"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "screenShareStopped", {
  enumerable: true,
  get: function get() {
    return _screenShareStopped["default"];
  }
});
var _screenShareStopped = _interopRequireDefault(require("./screenShareStopped"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }